// Layout del preventivo modificabile da Impostazioni (unica fonte per anteprima, PDF ed email).
export const DEFAULT_CARD_INCLUSO = [
  { titolo: "Manodopera", testo: "Tutte le lavorazioni edili comprese" },
  { titolo: "Impianti", testo: "Idraulico, elettrico, riscaldamento" },
  { titolo: "Finiture", testo: "Di livello professionale" },
  { titolo: "Pratiche", testo: "CILA/SCIA + capitolato" },
  { titolo: "Assistenza", testo: "Project manager dedicato" },
  { titolo: "Chiavi in mano", testo: "Un'unica formula completa" },
];

export const DEFAULT_LAYOUT = {
  logo_altezza: 96,
  mostra_ragione_sociale_logo: false,
  mostra_sito: false,
  mostra_indirizzo: true,
  mostra_telefono: true,
  mostra_email: true,
  mostra_pec: true,
  mostra_piva: true,
  mostra_cf: true,
  mostra_rea: true,
  mostra_sedi: true,
  titolo_sopra: "Proposta di ristrutturazione",
  intro_pacchetto: "Un'unica formula chiavi in mano: progettazione, lavori, materiali, finiture e assistenza durante e dopo i lavori. Trasparenza totale, prezzo bloccato.",
  mostra_card_incluso: true,
  card_incluso: DEFAULT_CARD_INCLUSO,
};

export const layoutPreventivo = (l) => {
  const out = { ...DEFAULT_LAYOUT, ...(l || {}) };
  if (!Array.isArray(out.card_incluso) || !out.card_incluso.length) out.card_incluso = DEFAULT_CARD_INCLUSO;
  return out;
};

// Copia esatta dell'anteprima (HTML + CSS della pagina) da cui il server genera il PDF.
export function snapshotAnteprima() {
  const el = document.getElementById("print-area").cloneNode(true);
  el.querySelectorAll("img").forEach((i) => i.setAttribute("src", i.src));
  el.querySelectorAll("[data-pdf-skip]").forEach((n) => n.remove());
  let css = "";
  for (const sh of document.styleSheets) {
    try { for (const r of sh.cssRules) css += r.cssText + "\n"; }
    catch (_) { if (sh.href) css += `@import url(${sh.href});\n`; }
  }
  return { html: el.outerHTML, css };
}
